import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import * as config from '../shared/config/app.config';
import * as saveAs from 'file-saver';
import { BaseService } from '../shared/services/base.service';
@Injectable({
  providedIn: 'root',
})
export class MakeAPaymentService {
  public creditInvoiceDate = new BehaviorSubject<any>(false); // behaviour subject containing the parent data of invoices & credit
  creditInvoiceDate$ = this.creditInvoiceDate.asObservable();
  public creditData = new BehaviorSubject<boolean>(false); // behaviour subject containing the credit Data
  creditData$ = this.creditData.asObservable();
  public invoicesData = new BehaviorSubject<boolean>(false); // behaviour subject containing the invoice Date
  invoicesData$ = this.invoicesData.asObservable();
  emails: any;
  emails$: any;
  constructor(private readonly baseService: BaseService) {}

  public getInvoices(params): void {
    this.baseService.get(config.GET_INVOICES, params).subscribe((res) => {
      this.creditInvoiceDate.next(res);
    });
  }
  public downloadPdf(params): void {
    this.baseService
      .getPdf(config.DOWNLOAD_INVOICE_CREDIT_PDF, { invoiceNumber: params })
      .subscribe((res) => {
        // const file = new Blob([res.body], { type: 'pdf' });
        // const fileURL = URL.createObjectURL(file);
        // window.open(fileURL);
        //saveAs(new Blob([res.body], { type: 'pdf' }), 'data.pdf'); this works
        //  const file = new Blob([res.body], { type: 'application/pdf' });
        //saveAs(file, 'text.pdf');
        // const fileURL = URL.createObjectURL(file);
        // window.open(fileURL);
        const file = new Blob([res], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      });
  }
  public getCardDetails(params): any {
    return this.baseService.get(config.GET_CARD_DETAILS, params);
  }
  public saveCreditDetails(userName, params) {
    return this.baseService.patch(
      `${config.USER_ACCOUNT}${userName}/payment-confirmation-credit`,
      params
    );
  }

  public makeCreditCardPayment(userName, params) {
    return this.baseService.post(
      `${config.USER_ACCOUNT}${userName}/ccinvoice-payment`,
      params
    );
  }

  public getAccountId(userName): Observable<any> {
    return this.baseService.get(`${config.USER_ACCOUNT}${userName}/b2bUnits`);
  }
  getEmails(userId, b2bUnitID): void {
    this.emails = new BehaviorSubject<any>(false);
    this.emails$ = this.emails.asObservable();
    this.baseService
      .get(
        `${config.USER_ACCOUNT}${userId}/customerEmails?b2bUnitId=${b2bUnitID}`
      )
      .subscribe((res) => {
        if (res) {
          this.emails.next(res);
        }
      });
  }
}
